export const VIRTUALIZED_TABLE_CONTAINER = 'virtualized-table-container';
export const VIRTUALIZED_TABLE_NO_RESULTS_TABLE_CELL_ID = 'virtualized-table-no-results-cell-id';
export const VIRTUALIZED_TABLE_NO_RESULTS_TEST_ID = 'virtualized-table-no-results';
export const VIRTUALIZED_TABLE_ID = 'virtualized-table-id';

export const FIXED_TABLE_HEADER_ID = 'fixed-table-header-id';
